export type ImageReplacementProps = {
  children: string;
};

export const ImageReplacement = ({ children }: ImageReplacementProps) => (
  <div style={{ display: 'block', whiteSpace: 'nowrap', textIndent: '-300vw', height: '0' }}>
    {children}
  </div>
);
